import React from "react";
const inputStyle = {
    width: "100%",
    lineHeight: "normal",
    // fontFamily: "Roboto-Regular",
    fontWeight: 400,
    borderRadius: "2px",
    backgroundColor: "#ffffff",
    border: "solid 1px #e8edf4",
    fontSize: 12,
    textAlign: "left",
    //WebkitTextFillColor: '#54698d',
    //color:'#54698d',
    opacity: 1,
    padding: "6px 6px 6px 6px"
    //border:'none',
    //padding:'6px 8px 3px 10px
};
export default class SearchAbleInputElement extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            value: props.value
        };
        this.onClickTextField = this.onClickTextField.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || ""
        });
    }

    onClickTextField(ev) {
        if (this.props.onClick) this.props.onClick(ev);
    }

    render() {
        let { title, style, placeholder, titleStyle, disabled, popoverOpen, required } = this.props;
        return (
            <div style={title ? { margin: "0px 0px" } : {}}>
                {title ? (
                    <div
                        style={Object.assign(
                            {
                                fontFamily: "Roboto-Regular",
                                fontSize: 12,
                                color: "#54698d",
                                marginBottom: 7
                            },
                            titleStyle
                        )}
                    >
                        {title + " "}
                        {required && <span style={{ color: "red" }}>*</span>}
                    </div>
                ) : null}
                <div style={{ position: "relative" }}>
                    <input
                        className={this.props.className || "searchableSelectTextInput"}
                        autoComplete="off"
                        ref="seachableInputElement"
                        type="text"
                        name={title}
                        disabled={disabled || false}
                        placeholder={`${placeholder || title}`}
                        style={Object.assign(
                            {
                                cursor: disabled ? "no-drop" : "pointer",
                                color:
                                    this.state.value == "Select"
                                        ? "#c7cdd5"
                                        : this.state.value == "Assign User"
                                        ? "#ea351f"
                                        : "#54698d"
                            },
                            inputStyle,
                            style
                        )}
                        value={this.state.value}
                        onClick={this.onClickTextField}
                        onChange={() => console.log("inside input")}
                    />
                    {this.props.onClick && (
                        <img
                            onClick={this.onClickTextField}
                            style={{
                                position: "absolute",
                                bottom: "calc(50% - 2px)",
                                right: "8px",
                                cursor: "pointer",
                                transform: popoverOpen ? "rotate(180deg)" : "rotate(0deg)"
                            }}
                            src="/assets/images/select-dropdown-icon.svg"
                            height="5"
                        />
                    )}
                </div>
            </div>
        );
    }
}
